// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "@/assets/js/store.js"
import axios from './http'
import VueAxios from 'vue-axios'
import Meta from 'vue-meta';
import MetaInfo from 'vue-meta-info'
import Pace from 'pace-progress'
import VueWait from 'vue-wait'

import VuePromiseBtn from 'vue-promise-btn'
import 'vue-promise-btn/dist/vue-promise-btn.css'
import i18n from '@/lang/lang.js'
import 'vue-tel-input/dist/vue-tel-input.css';


import QrcodeVue from 'qrcode.vue';
import VueHead from 'vue-head'


var SocialSharing = require('vue-social-sharing');
                            

Vue.use(VuePromiseBtn)
Vue.use(VueAxios, axios)
// Vue.use(Meta)
Vue.use(MetaInfo)
Vue.config.productionTip = false
Vue.use(VueWait)
Vue.use(SocialSharing);
Vue.use(VueHead)


/* eslint-disable no-new */
export const app =  new Vue({
  el: '#app',
  router,
  store,
   i18n,
  axios,
    wait: new VueWait({
      // Defaults values are following:
      useVuex: false, // Uses Vuex to manage wait state
      vuexModuleName: 'wait', // Vuex module name

      registerComponent: true, // Registers `v-wait` component
      componentName: 'v-wait', // <v-wait> component name, you can set `my-loader` etc.

      registerDirective: true, // Registers `v-wait` directive
      directiveName: 'wait', // <span v-wait /> directive name, you can set `my-loader` etc.

    }),
  components: { App },
  template: '<App/>',
    mounted() {
    // Pace.start()
    // Pace.on('hide', () => {
    //     document.dispatchEvent(new Event('app.rendered'));
    // })
    }
})



// WEBPACK FOOTER //
// ./src/main.js